import { Button } from "@mui/material";
import Form from "@poseidon/ui/components/form/FullWidthForm";
import { Panel } from "@poseidon/ui/components/Panel";
import {
  FormikDisabler,
  usePermissions,
} from "@poseidon/ui/components";
import { ToggleButtonControl } from "@poseidon/ui/components/ToggleButtonControl";
import config from "@poseidon/utils/config";
import { Formik } from "formik";

export const IdvStatus = ({ sailorRiskProfile, updateSailorRiskProfile }) => {
  const { canWrite } = usePermissions();
  const { idvOptions } = config;
  return (
    <Formik
      initialValues={{ idvStatus: sailorRiskProfile.idvStatus ?? "blocked" }}
      onSubmit={updateSailorRiskProfile}
      enableReinitialize
    >
      {({ dirty }) => (
        <Form>
          <FormikDisabler disabled={!canWrite} />
          <Panel
            title="Status"
            expandable
            actions={
              <Button
                variant="text"
                color="primary"
                type="submit"
                margin="normal"
                disabled={!dirty || !canWrite}
              >
                Save
              </Button>
            }
          >
            <ToggleButtonControl
              name="idvStatus"
              label="ID&amp;V Status"
              options={idvOptions}
              helperText={
                "This will be automatically set after running ID&V, and should not generally need changing manually"
              }
            />
          </Panel>
        </Form>
      )}
    </Formik>
  );
};
